import { setErrorDialog, serverUrl, getheader, getMethodByCallBack, cacheTypes } from "../../../store/api/CommonFunctions";

export function getCustomerLastService(customerID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE",
      data: "PENDING"
    })
    fetch(serverUrl + "/ReceptionTasksAPI/GetCustomerLastService?customerID=" + customerID, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات سرویس");
          res = {};
        }
        else if (res === "NotFound") {
          res = {};
        }
        res.CustomerID = customerID;
        dispatch({
          type: "GET_SERVICE",
          data: res
        });
      }).catch(e => console.log("[GET_SERVICE]", e))
  }
}
export function getCustomerServiceList(data) {
  return dispatch => {
    dispatch({
      type: "CUSTOMER_SERVICE_LIST",
      data: "PENDING"
    });
    dispatch({
      type:"CUST_SERVICE_FILTERS",
      data:data
    })
    fetch(serverUrl + "ReceptionTasksApi/GetCustomerServiceList", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت فهرست خدمات مشتری");
          res = null;
        }
        res.Data.forEach(s => {
          if ((s.GaranteeEndDate ?? "") !== "") {
            const eDate = new Date(s.GaranteeEndDate);
            const now = new Date();
            let remainedDays = eDate.getDate() - now.getDate();
            let remainedInMonth = eDate.getMonth() - now.getMonth()
              + (12 * (eDate.getFullYear() - now.getFullYear()));
            if (remainedDays < 0) {
              remainedInMonth--;
              remainedDays += new Date(eDate.getFullYear(), eDate.getMonth(), 0).getDate();
            }
            s.RemainedGuarantee = "";
            if (Math.abs(remainedInMonth) > 0) {
              s.RemainedGuarantee = Math.abs(remainedInMonth) + " ماه";
            }
            if (remainedDays !== 0) {
              if (s.RemainedGuarantee.length > 0) {
                s.RemainedGuarantee += " و ";
              }
              s.RemainedGuarantee += Math.abs(remainedDays) + " روز";
            }
            if (remainedInMonth >= 0 && remainedDays >= 0) {
              s.RemainedGuarantee += " مانده تا پایان گارانتی";
              s.Color = "green";
            }
            else {
              s.RemainedGuarantee += " گذشته از پایان گارانتی";
              s.Color = "red";
            }
          }
        });
        dispatch({
          type: "CUSTOMER_SERVICE_LIST",
          data: res
        });
      })
  }
}
export function applyService(data, fn) {
  const _header = getheader()
  return dispatch => {
    let serviceType = data.ServiceType;
    data = JSON.stringify(data)
    fetch(serverUrl + "ReceptionTasksApi/AddCustomerRequest/", {
      body: data,
      headers: _header,
      method: 'POST',
      cache: "no-cache"
    })
      .then(res => res.json())
      .then(res => {

        if (res.Message || isNaN(Number(res)) === true) {
          setErrorDialog(dispatch, res.Message ?? "", "ثبت سرویس");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت سرویس");
        fn(res, serviceType);
      }
      ).catch(err => {
        console.error('[ADD_SERVICE]', err);
      });
  };
}
export function getService(serviceType, serviceID) {
  return dispatch => {

    if (Number(serviceID) === 0) {
      return dispatch({
        type: "GET_SERVICE",
        data: null
      })
    }
    dispatch({
      type: "GET_SERVICE",
      data: "PENDING"
    })
    fetch(serverUrl + "ReceptionTasksApi/GetService?ServiceType=" + serviceType + "&&ServiceID=" + serviceID, {
      headers: getheader(),
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات پذیرش");
          res = null;
        }
        return dispatch({
          type: "GET_SERVICE",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE]', err);
        dispatch({
          type: "GET_SERVICE",
          data: null
        })
        setErrorDialog(dispatch, "Error", "دریافت اطلاعات پذیرش");
      });
  }

};
export function getActiveUnusedGuaranteeCards(cardNo, serialNumber, skip, take) {

  return dispatch => {
    if (!serialNumber && !cardNo) {
      alert("هیچکدام از فیلدهای جستجو پر نشده است");
      return dispatch({
        type: "ACTIVE_UNUSED_CARDS",
        data: []
      });
    }
    dispatch({
      type: "ACTIVE_UNUSED_CARDS",
      data: "PENDING"
    });
    fetch(serverUrl + `api/GuarantyAPI/GetActiveUnusedCard?serialNumber=${serialNumber ?? -1}&cardNo=${cardNo ?? -1}&skip=${skip ?? 0}&take=${take ?? 0}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (!res || res.status === "404" || res.status === "400") {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "GET_ACTIVE_UNUSED_CARDS",
            data: []
          });
          return;
        }
        if (res && !res.status && res === "Error") {
          alert("اشکال در ارتباط با سرور");
          dispatch({
            type: "ACTIVE_UNUSED_CARDS",
            data: []
          });
          return;
        }
        dispatch({
          type: "ACTIVE_UNUSED_CARDS",
          data: res
        })
      }

      ).catch(e => {
        dispatch({
          type: "ACTIVE_UNUSED_CARDS",
          data: null
        });
        console.log("[GET_ACTIVE_UNUSED_CARDS]", e)
      });
  }
}
export function getSerialHistory(serial, cardNo, customerCode, productCode) {

  return dispatch => {
    if (!serial && !cardNo && !customerCode && !productCode) {
      alert("هیچکدام از فیلدهای جستجو پر نشده است");
      return dispatch({
        type: "GET_SERIAL_HISTORY",
        data: []
      });
    }
    dispatch({
      type: "GET_SERIAL_HISTORY",
      data: "PENDING"
    });
    fetch(serverUrl + `api/GuarantyAPI/GetSerialHistory?serial=${serial ?? -1}&cardNo=${cardNo ?? -1}&customerCode=${customerCode ?? -1}&productCode=${productCode ?? -1}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (!res || res.status === "404" || res.status === "400") {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "GET_SERIAL_HISTORY",
            data: []
          });
          return;
        }
        if (res && !res.status && res === "Error") {
          alert("اشکال در ارتباط با سرور");
          dispatch({
            type: "GET_SERIAL_HISTORY",
            data: []
          });
          return;
        }
        dispatch({
          type: "GET_SERIAL_HISTORY",
          data: res
        })
      }

      ).catch(e => {
        dispatch({
          type: "GET_SERIAL_HISTORY",
          data: "PENDING"
        });
        console.log("[GET_SERIAL_HISTORY]", e)
      });
  }
}
export function getMessageList(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "SERVICE_MESSAGE_LIST",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetServiceMessageList?serviceID=${serviceID}&serviceType=${serviceType}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "SERVICE_MESSAGE_LIST",
          data: res
        });
      }).catch(e => {
        console.log("[SERVICE_MESSAGE_LIST]", e);
      })
  }
}
export function addNewMessage(data, fn) {
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/AddServiceMessage`, {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data),
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت پیام سرویس");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت پیام سرویس");
        if (fn) {
          fn(res);
        }
      }).catch(e => {
        console.log("[AddServiceMessage]", e);
      })
  }
}
export function deleteMessage(id, fn) {
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/DeleteServiceMessage`, {
      headers: getheader(),
      method: "POST",
      body: id,
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف پیام سرویس");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف پیام سرویس");
        if (fn) {
          fn(res);
        }
      }).catch(e => {
        console.log("[DeleteServiceMessage]", e);
      })
  }
}
export function getServiceStatusList(onGet) {
  getMethodByCallBack(`ReceptionTasksApi/GetServiceStatusList`, cacheTypes.NoCache, onGet, "GetServiceStatusList");
}
export function getServiceSummaryList(customerID, serial, onGet) {
  getMethodByCallBack(`ReceptionTasksApi/GetServiceSummaryList?customerID=${customerID}&serial=${serial ?? ""}`, cacheTypes.NoCache, onGet, "GetServiceSummaryList");
}